import { ArticleContentView } from "./ArticleContentView"

export const ArticleView = () => {
    return(
        <>
        <ArticleContentView/>
        </>
    )
}